export default {
  "path": "/demo/index",
  "meta": {
    "name": "demo-主页",
    "title": "主页",
    "isComponentDoc": true,
    "category": "Introduce"
  }
};